import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { black500, black400 } from '../../../../../constants/color';
import { PrimaryButon } from '@ui/components/common/button/PrimaryButon';
import { OutlineButon } from '@ui/components/common/button/OutlineButton';
export const SyncConfirmationDialog = ({ open, handleClose, handleSubmit }) => {
    return (_jsxs(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, children: [_jsxs(Box, { width: 717, sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                }, children: [_jsx(DialogTitle, { children: _jsx(Typography, { mt: 3, lineHeight: '48px', fontSize: '34px', fontWeight: 500, color: black500, children: "Sync Confirmation" }) }), _jsx(DialogContent, { children: _jsx(Typography, { variant: 'subtitle1', color: black400, children: "Resyncing these hours may create duplicate records in Business Central. Are you sure you want to proceed?" }) })] }), _jsxs(DialogActions, { children: [_jsx(OutlineButon, { onClick: handleClose, children: "Close" }), _jsx(PrimaryButon, { onClick: handleSubmit, children: "Confirm" })] })] }));
};
